var _defs, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWastewater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    height: 21,
    width: 21,
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title92"
  }, "airport.svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title92"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    id: "rect94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    rx: 10.5,
    ry: 10.5,
    fill: "#ffffff",
    id: "rect96"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-02",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 12.1,-17.5 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 1,-0.650391 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 14,-17.5 a 1,0.64999998 0 0 0 1,0.650391 A 1,0.64999998 0 0 0 16,-17.5 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m -1.0654834,10.084141 v 1.6818 l -6.4999999,-1 -0.3182,4.7727 2.8182,1.7273 v 1 l -3.5,-0.6818 -3.4999997,0.6818 v -1 l 2.8181997,-1.7273 -0.3182,-4.7727 -6.4999997,1 v -1.6818 l 6.4999997,-2.3182002 v -3 c 0,0 0,-1.5 1,-1.5 1,0 1,1.5 1,1.5 v 2.8182 z",
    id: "path98"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 1.19322
    },
    id: "path617",
    cx: -14.959525,
    cy: 4.305562,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      strokeWidth: 0.489146
    },
    id: "path1161-3",
    cx: -32.982548,
    cy: 6.0287619,
    rx: 1,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.338877,
      strokeDasharray: "none"
    },
    id: "path1161-5-6",
    cx: -32.982548,
    cy: 6.0287619,
    rx: 0.80000001,
    ry: 0.30000001
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 0.691758
    },
    id: "path1161-3-22",
    cx: 31,
    cy: 31.048004,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.415036,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6",
    cx: 31,
    cy: 31.048004,
    r: 0.60000002
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 35 31 A 1.25 1 0 0 0 36.25 32 A 1.25 1 0 0 0 37.5 31 L 37.25 31 A 1 0.60000002 0 0 1 36.25 31.599609 A 1 0.60000002 0 0 1 35.25 31 L 35 31 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 5 22.283203 A 1.25 1 0 0 0 6.25 23.283203 L 6.25 22.882812 A 1 0.60000002 0 0 1 5.25 22.283203 L 5 22.283203 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 8.0848016,22.335685 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.2500004,-1 h -0.25 a 1,0.60000002 0 0 1 -1.0000004,0.599609 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.773409,
      fillOpacity: 1
    },
    d: "M 5.5,24 A 1.25,1 0 0 0 6.75,25 1.25,1 0 0 0 8,24 H 7.75 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 5.75,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "M 7.75,24 A 1.25,1 0 0 0 9,25 1.25,1 0 0 0 10.250001,24 h -0.25 A 1,0.60000002 0 0 1 9,24.599609 1,0.60000002 0 0 1 8,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 10,24 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 10.25,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 12.25,24 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 14.5 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 12.5,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-0-8-8-5-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 14.5,24 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 14.75,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 13.25 22.333984 A 1 0.60000002 0 0 1 12.25 22.933594 L 12.25 23.333984 A 1.25 1 0 0 0 13.5 22.333984 L 13.25 22.333984 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "M 16.75,24 A 1.25,1 0 0 0 18,25 V 24.599609 A 1,0.60000002 0 0 1 17,24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-93",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.773409
    },
    d: "m 5.5,24 a 1,0.60000002 0 0 1 -1,0.59961 V 25 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 7,-23.6 a 1.25,1 0 0 0 1.25,1 v -0.400391 A 1,0.60000002 0 0 1 7.25,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 2.4999995,-23.6 A 1.25,1 0 0 0 3.75,-22.6 1.25,1 0 0 0 5,-23.6 H 4.75 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 2.7499995,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "M 4.7499995,-23.6 A 1.25,1 0 0 0 6,-22.6 a 1.25,1 0 0 0 1.25,-1 H 7 A 1,0.60000002 0 0 1 6,-23.000391 1,0.60000002 0 0 1 4.9999995,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 2.5,-23.6 a 1,0.60000002 0 0 1 -1,0.59961 V -22.6 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 18.5,-23.6 a 1.25,1 0 0 0 1.25,1 v -0.400391 A 1,0.60000002 0 0 1 18.75,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 13.999999,-23.6 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 14.249999,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-6-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 11.75,-23.6 a 1.25,1 0 0 0 1.25,1 1.25,1 0 0 0 1.25,-1 H 14 A 1,0.60000002 0 0 1 13,-23.000391 1,0.60000002 0 0 1 12,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7-5",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 16.249999,-23.6 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 H 18.5 a 1,0.60000002 0 0 1 -1,0.599609 A 1,0.60000002 0 0 1 16.499999,-23.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 11.75,-23.6 a 1,0.60000002 0 0 1 -1,0.59961 V -22.6 a 1.25,1 0 0 0 1.25,-1 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    id: "path1161-3-22-1-6",
    cx: 36.25,
    cy: 34,
    rx: 1.25,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#49ad54",
      fillOpacity: 1,
      strokeWidth: 0.535809,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-0-1",
    cx: 36.25,
    cy: 34,
    rx: 1,
    ry: 0.60000002
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "M -21 1.6503906 A 1 0.64999998 0 0 0 -20 2.3007812 A 1 0.64999998 0 0 0 -19 1.6503906 L -19.099609 1.6503906 A 0.89999998 0.5 0 0 1 -20 2.1503906 A 0.89999998 0.5 0 0 1 -20.900391 1.6503906 L -21 1.6503906 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 6.4000002,-17.5 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 1,-0.650391 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 8.3000002,-17.5 a 1,0.64999998 0 0 0 1,0.650391 A 1,0.64999998 0 0 0 10.3,-17.5 h -0.09961 a 0.89999998,0.5 0 0 1 -0.9003908,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 10.2,-17.5 a 1,0.64999998 0 0 0 1,0.650391 1,0.64999998 0 0 0 1,-0.650391 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5924-5",
    transform: "translate(12.53598,4.3752232)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect4784-4-2",
    width: 2,
    height: 12,
    x: 24.500038,
    y: -1.6689709
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-7-5",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: -0.668971
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-8-4",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 1.7310287
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-4-7",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 4.1310291
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-5-4",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 6.5310287
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5685-9-3-1-9-0-4",
    width: 1.2,
    height: 0.40000001,
    x: 25.300037,
    y: 8.9310293
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-3",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 35.836018,6.6115528 a 1,0.64999998 0 0 0 1,0.6503906 1,0.64999998 0 0 0 1,-0.6503906 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-6-0",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 37.736018,6.6115528 a 1,0.64999998 0 0 0 1,0.6503906 1,0.64999998 0 0 0 1,-0.6503906 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-62",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 3.9000002,-13 a 1,0.64999998 0 0 0 1,0.65039 A 1,0.64999998 0 0 0 5.9000001,-13 h -0.09961 a 0.89999998,0.5 0 0 1 -0.9003909,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-6",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 5.8000001,-13 a 1,0.64999998 0 0 0 1,0.65039 1,0.64999998 0 0 0 1,-0.65039 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-7",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 13.2,-13 a 1,0.64999998 0 0 0 1,0.65039 1,0.64999998 0 0 0 1,-0.65039 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-9",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 15.1,-13 a 1,0.64999998 0 0 0 1,0.65039 1,0.64999998 0 0 0 1,-0.65039 h -0.09961 a 0.89999998,0.5 0 0 1 -0.900391,0.5 0.89999998,0.5 0 0 1 -0.900391,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-9-7-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 26.9,2 a 1,0.64999998 0 0 0 1,0.65039 A 1,0.64999998 0 0 0 28.9,2 H 28.80039 A 0.89999998,0.5 0 0 1 27.899999,2.5 0.89999998,0.5 0 0 1 26.999608,2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-2-0-3-9-2",
    style: {
      fill: "#000000",
      strokeWidth: 0.557713
    },
    d: "m 28.8,2 a 1,0.64999998 0 0 0 1,0.65039 A 1,0.64999998 0 0 0 30.8,2 H 30.70039 A 0.89999998,0.5 0 0 1 29.799999,2.5 0.89999998,0.5 0 0 1 28.899608,2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-97-39",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 14.72034,26.347961 a 1.25,1 0 0 0 1.25,1 V 26.94757 a 1,0.60000002 0 0 1 -1,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-4",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 10.220339,26.347961 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1.000001,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-9-7-7-8",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 12.470339,26.347961 a 1.25,1 0 0 0 1.250001,1 1.25,1 0 0 0 1.25,-1 h -0.25 a 1,0.60000002 0 0 1 -1,0.599609 1,0.60000002 0 0 1 -1.000001,-0.599609 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-5-4-6-1",
    style: {
      fill: "#000000",
      strokeWidth: 0.773409
    },
    d: "m 10.22034,26.347961 a 1,0.60000002 0 0 1 -1.0000005,0.59961 v 0.40039 a 1.25,1 0 0 0 1.2500005,-1 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect4784",
    width: 2,
    height: 12,
    x: 25.093819,
    y: 5.6954908
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.052,
      strokeDasharray: "none"
    },
    id: "rect5682",
    width: 2,
    height: 12,
    x: 28.693171,
    y: 5.4010396
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 3.28586
    },
    id: "path1161-3-22-3-5",
    cx: 68.498589,
    cy: 21.061527,
    r: 4.75
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 2.93985,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-6-6",
    cx: 68.498589,
    cy: 21.061527,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48ad54",
      fillOpacity: 1,
      strokeWidth: 2.93985,
      strokeDasharray: "none"
    },
    id: "circle5288",
    cx: 68.498589,
    cy: 21.061527,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 1.19323
    },
    id: "path617-2-9",
    cx: 68.498589,
    cy: 21.061527,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.59661
    },
    id: "path617-2-2-7",
    cx: 68.498589,
    cy: 21.061527,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "none",
      fill: "#48ad54",
      fillOpacity: 1,
      strokeWidth: 2.93985,
      strokeDasharray: "none"
    },
    id: "circle5291",
    cx: 9.9235029,
    cy: 10.918221,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 3.28586
    },
    id: "path1161-3-22-3-4",
    cx: 38.560768,
    cy: 23.028198,
    r: 4.75
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 2.93985,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-6-5",
    cx: 38.560768,
    cy: 23.028198,
    r: 4.25
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 1.19322
    },
    id: "path617-2-0",
    cx: 38.560768,
    cy: 23.028198,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.596612
    },
    id: "path617-2-2-3",
    cx: 38.560768,
    cy: 23.028198,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.587877
    },
    id: "rect1711-6",
    width: 4.5,
    height: 0.80000001,
    x: 38.560768,
    y: 22.628197,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-3-0-1",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 3.28586
    },
    d: "m 42.791236,22.627807 a 4.25,4.25 0 0 1 0.01953,0.400391 4.25,4.25 0 0 1 -0.03125,0.400391 h 0.28125 v -0.800782 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.587877
    },
    id: "rect1711-1",
    width: 4.5,
    height: 0.80000001,
    x: 63.998589,
    y: 20.661528,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle5095",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 3.28586
    },
    d: "m 63.99859,20.661137 v 0.800782 h 0.28125 a 4.25,4.25 0 0 1 -0.03125,-0.400391 4.25,4.25 0 0 1 0.03125,-0.400391 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6666",
    transform: "matrix(1.7896732,0,0,1.7896732,-7.2588795,-9.0391007)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 3.28586
    },
    id: "path1161-3-22-3",
    cx: 9.9235029,
    cy: 10.918221,
    r: 4.75
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 2.70558,
      strokeDasharray: "none"
    },
    id: "path1161-5-6-6-6",
    cx: 9.9229736,
    cy: 10.917692,
    r: 3.9113286
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "none",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0152369,
      strokeDasharray: "none"
    },
    id: "rect4784-5",
    width: 0.2235045,
    height: 9.2195606,
    x: 9.8112211,
    y: 6.3079119
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 1.19322
    },
    id: "path617-2",
    cx: 9.9235029,
    cy: 10.918221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.596612
    },
    id: "path617-2-2",
    cx: 9.9235029,
    cy: 10.918221,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.587877
    },
    id: "rect1711",
    width: 4.5,
    height: 0.80000001,
    x: 9.9235029,
    y: 10.518221,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-3-0",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 4.14732
    },
    d: "m 13.820219,10.51783 a 6.770594,4.25 0 0 1 0.03111,0.400391 6.770594,4.25 0 0 1 -0.04979,0.400391 H 14.2496 V 10.51783 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastewater);
export default __webpack_public_path__ + "static/media/wastewater.88dc055400c9549e3e361493588b9322.svg";
export { ForwardRef as ReactComponent };